import { writable } from 'svelte/store';

const browseOptions = writable({
    assets: { searchText: null, infrastructure: "all", systemType: "all", dd1: "infrastructure", dd2: "systemType" },
    nhm: { searchText: null, entity: "all", dateRange: "all", dd1: "entity", dd2: "dateRange" },
    support: { searchText: null, docType: "all", dd1: "docType", dd2: null },
    utility: { searchText: null, dd1: null, dd2: null },
    work: { searchText: null, entity: "all", dateRange: "all", dd1: "entity", dd2: "dateRange" }
});

const browseOpts = {
    subscribe: browseOptions.subscribe,
    updateSearchText: (cat, data) => {
        browseOptions.update((prefs) => {
            prefs[cat].searchText = data;
            return prefs;
        });
    },
    updateDD1: (cat, data) => {
        var key = browseOpts.allOptions(cat).dd1;
        browseOptions.update((prefs) => {
            prefs[cat][key] = data;
            return prefs;
        });
    },
    updateDD2: (cat, data) => {
        var key = browseOpts.allOptions(cat).dd2;
        browseOptions.update((prefs) => {
            prefs[cat][key] = data;
            return prefs;
        });
    },
    setDefault: () => {
        browseOptions.set({
            work: { searchText: null, entity: "all", dateRange: "all" },
            assets: { searchText: null, infrastructure: "all", systemType: "all" },
            nhm: { searchText: null, entity: "all", dateRange: "all" },
            support: { searchText: null, docType: "all" },
            utility: { searchText: null }
        })
    },
    allOptions: (cat) => {
        return {
            assets: { dd1: "infrastructure", dd2: "systemType" },
            nhm: { dd1: "entity", dd2: "dateRange" },
            support: { dd1: "docType", dd2: null },
            work: { dd1: "entity", dd2: "dateRange" },
            utility: { dd1: null, dd2: null }
        }[cat];
    },
    dateRangeOptions: () => {
        return [
            { value: "all", title: "All Dates" },
            { value: "lastDays7", title: "Last 7 Days" },
            { value: "lastDays30", title: "Last 30 Days" },
            { value: "lastDays90", title: "Last 90 Days" },
            { value: "lastDays365", title: "Last 365 Days" },
            { value: "thisYear", title: "This Year" },
            { value: "lastYear", title: "Last Year" }
        ];
    },
    dropdownOptions: (cat) => {
        return {
            work: {
                dd1: [
                    { value: "all", title: "All Types" },
                    { value: "WorkOrder", title: "Work Orders" },
                    { value: "Issue", title: "Reported Issues" },
                    { value: "Activity", title: "Activities" },
                ],
                dd2: browseOpts.dateRangeOptions()
            },
            assets: {
                dd1: [
                    { value: "all", title: "All Infrastructures" },
                    { value: "Water", title: "Drinking Water" },
                    { value: "Electric", title: "Electric" },
                    { value: "Gas", title: "Gas" },
                    { value: "Storm", title: "Storm Water" },
                    { value: "Streets", title: "Streets" },
                    { value: "Waste", title: "Waste Water" },
                ],
                dd2: [
                    { value: "all", title: "All Systems" },
                    { value: "main", title: "Mains" },
                    { value: "service", title: "Service" },
                ],
            },
            nhm: {
                dd1: [
                    { value: "all", title: "All Data" },
                    { value: "SoundLocation", title: "Locations" },
                    { value: "Sensor", title: "Sensors" },
                ],
                dd2: browseOpts.dateRangeOptions()
            },
            support: {
                dd1: [
                    { value: "all", title: "All Types" },
                    { value: "Tutorial", title: "Tutorials" },
                    { value: "Guide", title: "Guides" },
                    { value: "TechnicalNote", title: "Technical Notes" },
                ],
                dd2: null
            },
            utility: {
                dd1: null,
                dd2: null
            }
        }[cat];
    }
}

export default browseOpts;
